// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration-header[data-v-3ee84ee0]{background-color:#fff;height:56px;align-items:center;justify-content:center;display:flex;position:fixed;top:0;width:100%;z-index:100;box-shadow:0 2px 20px 0 rgba(11,4,84,.08)}.registration-header-steps[data-v-3ee84ee0]{width:556px;text-align:left}:deep(.ivu-steps) .ivu-steps-item .ivu-steps-tail[data-v-3ee84ee0]{display:none!important}", ""]);
// Exports
module.exports = exports;
